import { LABEL_SLOTS } from "./layout/constants";
import { ART_PER_PAGE } from "./layout/artGeometryPt";

const chunkIntoPages = (items, size = 10) => {
  const pages = [];
  for (let i = 0; i < items.length; i += size) {
    pages.push(items.slice(i, i + size));
  }
  return pages;
};

const slotForIndex = (indexOnPage) => {
  if (indexOnPage < 0 || indexOnPage > 9) {
    throw new Error(`slot invalido: ${indexOnPage}`);
  }
  return LABEL_SLOTS[indexOnPage];
};

/** Cartas por página conforme o papel: 8 no `art` (unidade frente+verso), 10 nos demais. */
const perPageFor = (paper) => (paper === "art" ? ART_PER_PAGE : 10);

export { chunkIntoPages, slotForIndex, perPageFor };
